import React, { Component } from 'react';
import classNames from 'classnames';
import { FormattedMessage, FormattedDate, injectIntl } from 'react-intl';

import styles from './ISQListItem.module.scss';

class ISQListItem extends Component {
  getColor(item) {
    if (item.isq) {
      if (item.level === 'Abutment') {
        return styles.neutral;
      } else if (item.isq >= 70) {
        return styles.high;
      } else if (item.isq >= 60) {
        return styles.mid;
      } else if (item.isq > 0) {
        return styles.low;
      }
    }
    return styles.noMeasurement;
  }

  getList() {
    let measurements = [...this.props.data.measurements];
    measurements.sort((measurement, otherMeasurement) => {
      return new Date(measurement.date) - new Date(otherMeasurement.date);
    });
    if (this.props.all) {
      if (this.props.excludeAbutment) {
        const list = measurements.filter((item) => item.level === 'Implant');
        return list;
      }
      return measurements;
    }
    return [
      {
        id: this.props.data.currentMeasurementId,
        isq: this.props.data.currentIsq,
        isqMd: this.props.data.currentMd,
        isqBl: this.props.data.currentBl,
        type: this.props.data.currentType,
        date: this.props.data.currentMeasurementDate,
        level: this.props.data.currentLevel,
        measurement: measurements[measurements.length - 1],
      },
    ];
  }

  showMeasurementModal(measurement) {
    measurement = { ...measurement, BL: measurement.isqBl, MD: measurement.isqMd };
    if (this.props.showCreateMeasurementModal)
      this.props.showCreateMeasurementModal(this.props.data.tooth, true, measurement);
  }

  renderLabel() {
    return <div className={styles.label}>{this.props.label}</div>;
  }

  renderItems(items) {
    if (items) {
      return items.map((item) => {
        var type;
        if (item.type === 'DuringPlacement')
          type = <FormattedMessage id={'implant.placement'} defaultMessage={'Placement'} />;
        else if (item.type === 'DuringFollowup')
          type = <FormattedMessage id={'implant.followup'} defaultMessage={'Follow up'} />;
        else if (item.type === 'DuringLoading')
          type = (
            <FormattedMessage
              id={'implant.finalRestoration'}
              defaultMessage={'Final restoration'}
            />
          );

        return (
          <div className={styles.row} key={item.id}>
            <div className={styles.frame} key={item.id}>
              <div className={classNames(styles.isq, this.getColor(item))}>{item.isq}</div>
              <div className={styles.type}>{type}</div>
              {/* <div className={styles.blmd}>
                BL:{item.isqBl} MD:{item.isqMd}
              </div> */}
              {this.props.levelInfo && item.level === 'Abutment' && (
                <div className={styles.levelInfo}>
                  (<FormattedMessage id="implant.abutment" defaultMessage="Abutment" />)
                </div>
              )}
              <div className={styles.date}>
                <FormattedDate value={item.date} year="numeric" month="short" day="numeric" />
              </div>
            </div>
            {this.props.showCreateMeasurementModal && (
              <button
                className={classNames(styles.frame, styles.edit)}
                onClick={() => {
                  this.showMeasurementModal(item);
                }}
              >
                draw
              </button>
            )}
          </div>
        );
      });
    }
  }

  render() {
    const measurements = this.getList();
    return (
      <div className={styles.ISQitem}>
        {this.renderLabel()}
        {this.renderItems(measurements)}
      </div>
    );
  }
}

export default injectIntl(ISQListItem);
